export type AgencyStatusAction = 'suspend' | 'activate'

export function isAgencyActive(status: string): boolean {
  return status.trim().toLowerCase() === 'active'
}

export function isAgencySuspended(status: string): boolean {
  const normalized = status.trim().toLowerCase()
  return normalized === 'suspended' || normalized === 'inactive'
}

export function getAgencyStatusAction(status: string): AgencyStatusAction | null {
  if (isAgencyActive(status)) {
    return 'suspend'
  }
  if (isAgencySuspended(status)) {
    return 'activate'
  }
  return null
}
